import { render } from "./index.vue?vue&type=template&id=5640672e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5640672e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5640672e"],['__file',"src/extra/VabAvatarList/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5640672e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5640672e', __exports__)) {
    console.log('reload')
    api.reload('5640672e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5640672e&scoped=true", () => {
    console.log('re-render')
    api.rerender('5640672e', render)
  })

}


export default __exports__